/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useMutation } from 'react-query';
import moment from 'moment';

import { beginSmsOtp, authenticateSmsOtp } from '~/api/onboarding';
import { auth } from '~/api/axios';
import useReduxState from '~/hooks/useReduxState';
import useLocalStorage from '~/hooks/useLocalStorage';

interface SmsOtpState {
  challengeToken: string | null;
  phoneNumber: string | null;
}

export const useSmsOtpState = () => {
  return useReduxState<SmsOtpState>('smsOtp', {
    challengeToken: null,
    phoneNumber: null,
  });
};

export const useResendOtpCodeState = () => {
  return useLocalStorage<string | null>('canResendSmsTimestamp', null);
};

export const useBeginSmsOptMutation = () => {
  const [, setState] = useSmsOtpState();
  const [, setResendTimestamp] = useResendOtpCodeState();

  return useMutation(
    (req: { phoneNumber?: string; invitationToken?: string; captchaToken?: string }) =>
      beginSmsOtp(req).then((res) => res.data),
    {
      onSuccess(data, req) {
        const { challengeToken } = data;
        setState((prev) => ({
          ...prev,
          challengeToken,
          phoneNumber: req.phoneNumber || null,
        }));
        setResendTimestamp(moment().add(1, 'minute').toISOString());
      },
    }
  );
};

export const useConfirmSmsOtpCodeMutation = () => {
  const [state, setState] = useSmsOtpState();
  const [, setResendTimestamp] = useResendOtpCodeState();

  return useMutation(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (otp: string) => authenticateSmsOtp(state.challengeToken!, otp).then((res) => res.headers),
    {
      onSuccess(headers) {
        auth.setToken(headers, 'smsOtp');
        setState((props) => ({ ...props, challengeToken: null }));
        setResendTimestamp(null);
      },
    }
  );
};
